export const promoApplicableDiscountForFirstPayment = [
    'FIRST_PAYMENT',
    'ALL',
];
export const promoApplicableDiscountForRenew = [
    'RENEW',
    'ALL',
];
